import { HelpVideoChildComponent } from '../helpVideoChildComponent';

const JobsDescription = () => {
  const topicList = [
    { id: '827909021', label: 'How to post and manage Jobs' },
    { id: '851310217', label: 'How to search your job on Wisestep' },
    { id: '851301468', label: 'How to edit your Jobs on Wisestep' },
    { id: '851303310', label: 'How to save your Jobs in Wisestep' },
  ];
  return <HelpVideoChildComponent isFromSettings={true} topicArrayList={topicList} />;
};

export default JobsDescription;
